angular.module( 'acme.view.application.pos.create.pages.forms.tile', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.pages.forms.tile.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreatePagesFormsTile = {
        name: 'application.pos.create.pages.forms.tile',
        url: '/tile',
        views: {
          "subview-main": {
            controller: 'PosCreatePagesFormsTileController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/pages/forms/tile/tile.tpl.html'
          }
        },
        data: {
          pageTitle: '     ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(posCreatePagesFormsTile);
});
